import React from 'react';

const copyBlocks = [
  {
    title: '1) Install Homebrew if this fresh Mac does not have it',
    body: String.raw`/bin/bash -c "$(curl -fsSL https://raw.githubusercontent.com/Homebrew/install/HEAD/install.sh)"
eval "$(/opt/homebrew/bin/brew shellenv)"`,
  },
  {
    title: '2) Install Tailscale without the App Store',
    body: String.raw`brew install --cask tailscale-app
open -a Tailscale`,
  },
  {
    title: '3) Sign in and name the machine',
    body: String.raw`# In the Tailscale window:
# - Sign in with Adam@roofingbusinesspartner.com
# - Name the machine after the agent/client, e.g. jarvis, ragnor, geo
# - Confirm it shows Connected`,
  },
  {
    title: '4) Give Terminal Full Disk Access, then enable SSH/Remote Login',
    body: String.raw`# Do this once on the Mac:
# System Settings > Privacy & Security > Full Disk Access
# Turn ON Terminal. If Terminal is not listed, click + and add it from /Applications/Utilities/Terminal.app
# Quit and reopen Terminal after enabling it.

mkdir -p ~/.ssh
chmod 700 ~/.ssh
cat >> ~/.ssh/authorized_keys <<'EOF'
ssh-ed25519 AAAAC3NzaC1lZDI1NTE5AAAAIHedWV63dnverXuBKKfExkvsdd4TYb3aAfU5G/73slVk vito-roofclaw-build-2026-05-04
EOF
chmod 600 ~/.ssh/authorized_keys
sudo systemsetup -setremotelogin on`,
  },
  {
    title: '5) After Vito is done, turn Terminal Full Disk Access back off',
    body: String.raw`# System Settings > Privacy & Security > Full Disk Access
# Turn OFF Terminal again after the build session is complete.
# Leave Remote Login on only if Adam wants Vito to keep support access.
# Otherwise run:
sudo systemsetup -setremotelogin off`,
  },
  {
    title: '6) Send Vito the machine name and Tailscale IP',
    body: String.raw`/Applications/Tailscale.app/Contents/MacOS/Tailscale status
/Applications/Tailscale.app/Contents/MacOS/Tailscale ip -4
whoami`,
  },
];

const TailscaleMethodPage = () => {
  return (
    <div className="bg-[#0A0A14] text-[#F0EFF4]">
      <section className="mx-auto max-w-5xl px-6 py-16 sm:py-20">
        <p className="text-sm font-semibold uppercase tracking-[0.3em] text-[#7B61FF]">RoofClaw build night</p>
        <h1 className="mt-4 text-4xl font-black tracking-tight sm:text-5xl">Tailscale setup without an Apple ID</h1>
        <p className="mt-5 max-w-3xl text-lg leading-8 text-[#C9C7D1]">
          Use this on a fresh RoofClaw Mac when the App Store method is blocked. This gets the machine onto Adam's Tailnet and enables temporary SSH access so Vito can finish the OpenClaw install, patching, diagnostics, and deployment from the build chat.
        </p>

        <div className="mt-8 rounded-2xl border border-amber-400/30 bg-amber-400/10 p-5 text-amber-100">
          <p className="font-bold">Security note</p>
          <p className="mt-2 text-sm leading-6">
            These commands contain no private API keys or passwords. They do add Vito's public SSH key, require Terminal Full Disk Access temporarily, and turn on Remote Login. Turn Terminal Full Disk Access back off after the build session, and remove build access after delivery if the client does not need ongoing support access.
          </p>
        </div>

        <div className="mt-10 space-y-6">
          {copyBlocks.map((block) => (
            <article key={block.title} className="rounded-2xl border border-white/10 bg-white/[0.04] p-5 shadow-2xl shadow-black/20">
              <h2 className="text-xl font-bold text-white">{block.title}</h2>
              <pre className="mt-4 overflow-x-auto rounded-xl border border-white/10 bg-black/60 p-4 text-sm leading-6 text-green-200"><code>{block.body}</code></pre>
            </article>
          ))}
        </div>

        <div className="mt-10 rounded-2xl border border-white/10 bg-[#111122] p-6">
          <h2 className="text-2xl font-black">What happens next</h2>
          <ul className="mt-4 list-disc space-y-2 pl-5 text-[#C9C7D1]">
            <li>Adam sends Vito the Tailscale IP, machine name, and macOS username.</li>
            <li>Vito connects over Tailscale SSH and runs the RoofClaw bootstrap.</li>
            <li>Vito installs Homebrew, Node, OpenClaw, skills, workspace files, and agent identity.</li>
            <li>Vito verifies the dashboard, agent context, FileVault/hardening status, and shipping blockers.</li>
          </ul>
        </div>

        <p className="mt-8 text-sm text-[#8C8999]">
          Temporary page for internal RoofClaw deployment acceleration. If you found this by accident, congratulations, friend, you found a checklist, not a backdoor.
        </p>
      </section>
    </div>
  );
};

export default TailscaleMethodPage;
